<template>
  <div>
    <form
      autocomplete="off"
      @submit.prevent="handleSubmit"
    >
      <template v-if="error">
        <p class="text-red-500 p-2 bg-red-100 rounded text-center">
          {{ error }}
        </p>
      </template>

      <div>
        <div class="input-field">
          <label for="email">Email</label>
          <input
            id="email"
            v-model="formData.email"
            v-focus
            type="email"
            required
          >
        </div>

        <div class="input-field">
          <label for="password">Password</label>
          <PasswordInput
            v-model="formData.password"
            required
          />
        </div>

        <AppButton
          :disabled="isSubmitting"
          class="w-full btn-solid-primary"
          :class="{ 'opacity-50' : isSubmitting }"
        >
          {{ isSubmitting ? 'Signing in...' : 'Sign in' }}
        </AppButton>

        <div class="mt-4 text-center">
          <RouterLink
            class="link-blue"
            :to="{ name: 'app_auth_forgot_password' }"
          >
            Forgot password
          </RouterLink>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';

import { AppButton } from '@/components/buttons';

import { useHttp } from '@/composables';
import { useAuthStore } from '@/store';
import { PasswordInput } from '@/components/form-inputs/index.js';

const router = useRouter();
const authStore = useAuthStore();

const error = ref(null);

const formData = reactive({
  email: import.meta.env.DEV ? 'admin@example.com' : null,
  password: import.meta.env.DEV ? 'password' : null,
});

const isSubmitting = ref(false);

const handleSubmit = async () => {
  isSubmitting.value = true;
  error.value = null;

  const response = await useHttp().post('/auth/login', formData);

  if (response.statusCode === HttpStatusCode.Ok) {
    authStore.$patch({ user: response.data });

    if (authStore.user.districts.length === 1) {
      const currentDistrict = authStore.user.districts.find(district => district.current);

      await router.push({ name: 'app_plan_list', params: { district: currentDistrict.id } });
    } else {
      await router.push({ name: 'app_district_select' });
    }
  } else if ([HttpStatusCode.Unauthorized, HttpStatusCode.BadRequest].includes(response.statusCode)) {
    error.value = 'Email/password is incorrect';
  } else {
    error.value = response.exception;
  }

  isSubmitting.value = false;
};
</script>
